import React, { memo, useEffect, useState, useCallback } from 'react';
import AppCard from '../Card/AppCard/AppCard';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './AppEquity.module.less';
import InfiniteScroll from 'react-infinite-scroller';
import Loading from '../../../components/Loading/Loading';
import { getAppsList } from '../../../actions/order';
import Default from '../../../static/order_lack.svg';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import { logging, logPostInfo } from '../../../actions/log';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import AppPrompt from '../Card/AppPrompt/AppPrompt';
import { PCStoreJsBridge } from '../../../nativeapi';
import DefaultLogin from '../DefaultLogin/DefaultLogin';

const selectAppList = createSelector(
  state => state.order,
  order => order,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ node }) => {
  const loginStatus = useLoginStatus();
  const history = useHistory();
  const dispatch = useDispatch();
  let nowPage = 1;
  const { appOrders, appTotal, appLoading } = useSelector(selectAppList);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    if (!sessionStorage.getItem('APP_ORDER_ID')) {
      PCStoreJsBridge.getDeviceId().then(res => {
        if (res?.succ) {
          sessionStorage.setItem('APP_ORDER_ID', res?.deviceID);
          dispatch(
            getAppsList({
              deviceId: sessionStorage.getItem('APP_ORDER_ID'),
              page: 1,
              size: 24,
              refresh: true,
            }),
          );
        }
      });
    }
    if (loginStatus && appOrders && appOrders.length !== 0) {
      dispatch(
        logging({
          category: 'P',
          action: 'App_Equity',
          label: '',
          param2: {
            source: 'App_Equity',
            source_p: logInfoData.source,
            source_pp: logInfoData.source_p,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source: 'App_Equity',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('APP_ORDER_ID')) {
      dispatch(
        getAppsList({
          deviceId: sessionStorage.getItem('APP_ORDER_ID'),
          page: 1,
          size: 24,
          refresh: true,
        }),
      );
    }
  }, [loginStatus]);

  const loadMore = useCallback(() => {
    nowPage++;
    dispatch(
      getAppsList({
        deviceId: sessionStorage.getItem('APP_ORDER_ID'),
        page: nowPage,
        size: 24,
        refresh: false,
      }),
    );
  }, [nowPage]);

  const jumpOther = () => {
    history.push(`${CONTEXT}/recommend`);
  };

  const handelLogin = () => {
    window && window.CallNativeMethod && window.CallNativeMethod('login');
  };

  return (
    <div className={styles.app_orders}>
      {/* <AppPrompt /> */}

      {appLoading && (
        <div className={styles.default}>
          <Loading />
        </div>
      )}
      {!appLoading && (
        <>
          {appOrders.length !== 0 && (
            <div className={styles.app_order_info}>
              <InfiniteScroll
                page={1}
                loadMore={loadMore}
                hasMore={(appOrders && appOrders.length) < appTotal}
                loader={
                  <div className="loader" key={0}>
                    ----------加载中----------
                  </div>
                }
                initialLoad={false}
                useWindow={false}
                getScrollParent={() => node}
              >
                {appOrders.map((el, index) => (
                  <AppCard info={el} key={index} />
                ))}
              </InfiniteScroll>
              {!loginStatus && (
                <div className={styles.guide_login}>
                  <span className={styles.b_desc}>登录后，查看更多订单</span>
                  <span className={styles.g_desc} onClick={handelLogin}>
                    {'立即登录 >'}
                  </span>
                </div>
              )}
            </div>
          )}

          {appOrders?.length === 0 && loginStatus && (
            <div className={styles.default}>
              <div>
                <img src={Default} />
              </div>
              <div className={styles.describe}>
                <span>您暂时还没有订单</span>
                <span className={styles.jump_other} onClick={jumpOther}>
                  去逛逛
                </span>
              </div>
            </div>
          )}
          {!loginStatus && appOrders?.length === 0 && <DefaultLogin />}
        </>
      )}
    </div>
  );
});
